/* eslint-disable max-len */
import { SvgIcon } from '@mui/material';
import { CustomSvgIcon } from '@tassat/ui-definitions';
import * as React from 'react';

export default function Cancel(props: CustomSvgIcon) {
    const {
        id,
        className,
        iconColor,
        onClick
    } = props;

    return (
        <SvgIcon
            className={className || ''}
            id={id || ''}
            onClick={onClick}
        >
            <svg xmlns='http://www.w3.org/2000/svg'>
                <g>
                    <title>Cancel</title>
                    <g
                        id='svg_6'
                        stroke='null'
                    >
                        <g
                            fillRule='nonzero'
                            id='color-'
                        >
                            <polygon
                                fill={iconColor || '#000'}
                                id='svg_5'
                                points='22.794052124023438,2.8743715286254883 21.154449462890625,1.2892742156982422 12,10.392258167266846 2.8455498218536377,1.2892742156982422 1.205946922302246,2.8743715286254883 10.4059419631958,11.977357387542725 1.205946922302246,21.125629901885986 2.8455498218536377,22.710726261138916 12,13.607739925384521 21.154449462890625,22.710726261138916 22.794052124023438,21.125629901885986 13.5940580368042,11.977357387542725 '
                                stroke='null'
                            />
                        </g>
                    </g>
                </g>
            </svg>
        </SvgIcon>
    );
}